import { string, shape } from 'prop-types';
import React, { Fragment } from 'react';

function EmailSignupLoadingMessage(props) {
  const { error } = props;

  return (
    <section className="EmailSignup__form-loading">
      {error === undefined ? (
        <p>Loading Email Sign-Up Form...</p>
      ) : (
        <Fragment>
          <p>{error.msg}</p>
          {/* prettier-ignore */}
          <p>Try our <a href="/mailing-list">mailing list page</a> instead.</p>
        </Fragment>
      )}
    </section>
  );
}

EmailSignupLoadingMessage.propTypes = {
  error: shape({
    msg: string.isRequired
  })
};

EmailSignupLoadingMessage.defaultProps = {
  error: undefined
};

export default EmailSignupLoadingMessage;
